import { Heading, Text } from '@cinch-labs/design-system'

import {
  TextInlineImageCard,
  TextInlineImageCardProps,
} from './text-inline-image-card/text-inline-image-card'
import styles from './text-inline-image-section.module.css'

export interface TextInlineImageSectionProps {
  title: string
  body: string
  textInlineImages: TextInlineImageCardProps[]
}

export const TextInlineImageSection: React.FC<TextInlineImageSectionProps> = ({
  title,
  body,
  textInlineImages,
}) => (
  <div className={styles.wrapper}>
    {title && (
      <Heading element="h2" className={styles.title}>
        {title}
      </Heading>
    )}

    {body && <Text className={styles.body}>{body}</Text>}

    <div className={styles.cardsWrapper}>
      {textInlineImages.map((item, index) => (
        <TextInlineImageCard
          key={'card ' + index}
          headingLeftText={item.headingLeftText}
          headingRightText={item.headingRightText}
          headingLogo={item.headingLogo}
          body={item.body}
          image={item.image}
          imagePosition={item.imagePosition}
        />
      ))}
    </div>
  </div>
)
